import { render, staticRenderFns } from "./NewsTickerArticle.vue?vue&type=template&id=601a699b&"
import script from "./NewsTickerArticle.vue?vue&type=script&lang=js&"
export * from "./NewsTickerArticle.vue?vue&type=script&lang=js&"
import style0 from "./NewsTickerArticle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports